import React, { useState } from 'react';
import { InputBase, makeStyles } from '@material-ui/core';
import { classNames, onKeyUpEnterOrSpace } from '../../utils';
import { DropDownIcon } from '../Icon';
import DropSelectPop from './DropSelectPop';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    height: '3.5rem',
    width: '25rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '0.625rem',
    background: '#fff',
  },
  inputBase: {
    height: '100%',
    width: '100%',
    borderRadius: '0.625remm',
    paddingLeft: '1.25rem',
    '& .MuiInputBase-input': {
      fontSize: '1rem',
      color: '#2e4469',
      fontFamily: 'NotoSans-Medium',
    },
  },
  dropDownIcon: {
    position: 'absolute',
    top: '50%',
    right: '1rem',
    transform: 'translateY(-50%)',
    height: '0.875rem',
    width: '0.875rem',
    color: '#538fff',
  },
}));

export default function DropSelectInput({ className, value, placeholder, children, onChange }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const inputHandle = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const closePop = () => {
    setAnchorEl(null);
  };

  const getValue = () => {
    return children.find((element) => {
      return element.props.value === value;
    }).props.children;
  };

  const [isDrowRotate, setSsDrowRotate] = useState(false);
  const inputChange = (data) => {
    setSsDrowRotate(!isDrowRotate);
    onChange(data);
  };

  return (
    <div>
      <div
        className={classNames(classes.root, className)}
        onClick={inputHandle}
        tabIndex={0}
        onKeyUp={(e) => onKeyUpEnterOrSpace(e, inputHandle)}
      >
        <InputBase className={classes.inputBase} disabled value={value && getValue()} placeholder={placeholder} />
        <DropDownIcon className={classes.dropDownIcon} />
      </div>
      {anchorEl ? (
        <DropSelectPop
          anchorEl={anchorEl}
          onClose={closePop}
          onChange={inputChange}
          children={children}
          value={value}
         />
      ) : (
        ''
      )}
    </div>
  );
}
